/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DocumentStats } from './DocumentStats';
import {
    DocumentStatsFromJSON,
    DocumentStatsFromJSONTyped,
    DocumentStatsToJSON,
} from './DocumentStats';

/**
 * 
 * @export
 * @interface LeadDocumentStats
 */
export interface LeadDocumentStats {
    /**
     * 
     * @type {string}
     * @memberof LeadDocumentStats
     */
    lead_id: string;
    /**
     * 
     * @type {Array<DocumentStats>}
     * @memberof LeadDocumentStats
     */
    documents: Array<DocumentStats>;
}

/**
 * Check if a given object implements the LeadDocumentStats interface.
 */
export function instanceOfLeadDocumentStats(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "documents" in value;

    return isInstance;
}

export function LeadDocumentStatsFromJSON(json: any): LeadDocumentStats {
    return LeadDocumentStatsFromJSONTyped(json, false);
}

export function LeadDocumentStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadDocumentStats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'documents': ((json['documents'] as Array<any>).map(DocumentStatsFromJSON)),
    };
}

export function LeadDocumentStatsToJSON(value?: LeadDocumentStats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_id': value.lead_id,
        'documents': ((value.documents as Array<any>).map(DocumentStatsToJSON)),
    };
}

